import React from "react";
import "./AccountNotices.scss";

function amountText(value, language) {
  if (typeof value !== "string" && typeof value !== "number") return null;
  if (!/^-?\d+(?:\.\d{1,2})?$/.test(String(value))) return null;
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) return null;
  return `CHF ${new Intl.NumberFormat(language === "en" ? "en-CH" : "de-CH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)}`;
}

function dueText(value, language) {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = new Date(`${value}T12:00:00`);
  if (!Number.isFinite(date.getTime()) ||
      date.getFullYear() !== Number(value.slice(0, 4)) ||
      date.getMonth() + 1 !== Number(value.slice(5, 7)) ||
      date.getDate() !== Number(value.slice(8, 10))) return null;
  return date.toLocaleDateString(language === "en" ? "en-GB" : "de-CH");
}

export default function AccountNotices({ status, language = "de" }) {
  if (!status) return null;
  const english = language === "en";
  return (
    <div className="account-notices" aria-live="polite">
      {status.openPayments?.length > 0 && (
        <section className="account-notice account-notice--payment" aria-label={english ? "Open payments" : "Offene Zahlungen"}>
          <h2>{english ? "Open payment" : "Offene Zahlung"}</h2>
          <ul>
            {status.openPayments.map((payment) => {
              const amount = amountText(payment.amount, language);
              const due = dueText(payment.due_date, language);
              return (
                <li key={payment.key}>
                  <strong>{payment.label}</strong>
                  {amount && <span> · {amount}</span>}
                  {due && <span> · {english ? "Due: " : "Fällig: "}{due}</span>}
                </li>
              );
            })}
          </ul>
          <p>{english ? "Please settle this at reception." : "Bitte am Empfang begleichen."}</p>
        </section>
      )}
      {status.profileReviews?.map((review) => (
        <section key={review.key} className="account-notice account-notice--review">
          <h2>{review.title}</h2>
          <p>{english ? "Please contact reception so we can clarify this with you." : "Bitte am Empfang melden, damit wir das gemeinsam klären können."}</p>
        </section>
      ))}
      {status.unavailable && (
        <section className="account-notice account-notice--review">
          <h2>{english ? "Account status: check unavailable" : "Kontostatus: Prüfung derzeit nicht verfügbar"}</h2>
          <p>{english ? "Please reload the page. If this continues, contact reception." : "Bitte lade die Seite erneut. Falls der Hinweis bleibt, melde dich am Empfang."}</p>
        </section>
      )}
    </div>
  );
}
